<template>
  <div class="CInventory">
    <div>
      <div class="icon"><img src="../../../../../../static/images/loading.gif" alt=""></div>
      <div class="name">盘点中，请稍后</div>
    </div>
    <currtime :isShowInfo="true"></currtime>
  </div>
</template>

<script>
import currtime from '../../../../../assets/currTime'
import mqttws from '../../../../../assets/mqttws'
import { checkData } from '../../../../../../static/js/utils/util.js'
import { adminApi,wareApi } from '../../../../../../static/js/api.js'
import * as config from '../../../../../../static/js/config.js';
import { localUserInfo,storage,conLog } from '../../../../../../static/js/utils/utility.js'
import {websocketsend} from  '../../../../../../static/js/utils/socket.js'
export default {
  name: 'CInventory',
  data () {
    return {
      user_id:'',
      user_name:'',
      boxId:'',

      topic:'/'+ config.serverPort +'/down/'+ config.clientPort +'/control/protocol/response',
      msg:'',
      isConnect:true,//是否默认订阅

      topic2:'/'+ config.serverPort +'/down/'+ config.clientPort +'/control/protocol',
      msg2:'',
      isSend:true,

      time2:30,
      timeStatus2:'',

      project_type:'',
    }
  },
  mounted(){

  },
  created(){
    var that = this
    this.boxId = this.$route.query.boxId
    this.user_id = localUserInfo.getItem().user_id
    this.user_name = localUserInfo.getItem().user_name
    var configStorage = JSON.parse(localStorage.getItem('configStorage'))
    if(configStorage){
      this.project_type = configStorage.unmanShow
    }
    var boxId =this.$route.query.boxId
    
    var time = Date.parse(new Date())/1000;//精确到秒时间戳
    //1为借出，3为管理员入库
    var str = 'd707'+boxId+','+this.user_id+',1,'+time+','
    this.sendMsg = str
    websocketsend(this.sendMsg);
    // if(boxId <= 9){
    //   boxId = '0'+boxId
    // }

    this.getSecond2(this.time2)

    if(that.project_type == '1'){
      // var msg = 'a5551505160101010000000101d6040001'+boxId;
      var msg = 'a5551505160101010000000101d6080001'+boxId
      var num = checkData(msg)
      msg = msg+num
      that.msg2 = msg
      
    }else if(that.project_type == '2'){
      var msg2 = 'a5551505160101010000000101d7070001'+boxId;
      var num = checkData(msg2)
      msg2 = msg2+num
      that.msg2 = msg2
    }
    
  },
  components:{
    mqttws,
    currtime
  },
  methods:{
    //接收socket
    getSkMsg(res){
      console.log('ad',res)
      var that = this;
      if(res){
        if(res.meta){
          if(res.meta.fun_code == 'd707'){
            if(res.meta.code == 200){
              clearTimeout(that.timeStatus2)
              storage.sessionSetItem('boxInventory',res.body)
              that.$router.push({
                path:'/toolCabinet/CCloseDoor',
                query:{
                  boxId:that.boxId,
                  type:'1',//1借用2归还3管理员入库（自定义）
                }
              })
            }else{
              clearTimeout(that.timeStatus2)
              // that.$refs.mqttws.disconnect()
              that.$message.error(res.meta.message)
              that.$router.push({
                path:'/toolCabinet/CBorrow',
              })
            }
          }else{

          }
        }
      }
    },

    //返回
    backUp(){
      this.$router.push({
        path:'/toolCabinet/CBorrow'
      })
    },
    //倒计时
    getSecond2(wait){
      conLog('CInventorygetSecond2',wait)
      var that = this;
      var _wait = wait;
      if(wait == 0) {
        wait = _wait;
        clearTimeout(that.timeStatus2)
        // that.$router.go(0)
        that.backUp()
      } else {
        this.time2=wait
        wait--;
        that.timeStatus2 = setTimeout(function() {
          that.getSecond2(wait);
        },1000);
      }
    },
    //盘点
    async borrowReturn(data){
      var that = this;
      var dataObj = {
        'location_id': that.boxId,
        'user_id': that.user_id,
        'user': that.user_name,
        'cabinet_id': config.deviceId,
        'type': '1',
        'data': data,
        'way':'usual',
      }
      var res = await adminApi.borrowReturn(dataObj);
      
      if(res.meta.code == 200){
        clearTimeout(that.timeStatus2)
        storage.sessionSetItem('boxInventory',res.body)
        // that.$refs.mqttws.disconnect()
        that.$router.push({
          path:'/toolCabinet/CCloseDoor',
          query:{
            boxId:that.boxId,
            type:'1',//1借用2归还3管理员入库（自定义）
          }
        })
      }else{
        clearTimeout(that.timeStatus2)
        // that.$refs.mqttws.disconnect()
        that.$message.error(res.meta.message)
        that.$router.push({
          path:'/toolCabinet/CBorrow',
        })
      }
    },
    async borrowReturn2(data){
      var that = this;
      var dataObj = {
        'location_id': that.boxId,
        'user_id': that.user_id,
        'user':that.user_name,
        'cabinet_id': config.deviceId,
        'type': '1',
        'data': data,
      }
      var res = await wareApi.medicalAct(dataObj);
      if(res.meta.code == 200){
        clearTimeout(that.timeStatus2)
        // console.log(res.body)
        storage.sessionSetItem('boxInventory',res.body)
        // sessionStorage.setItem('boxInventory',JSON.stringify(res.body))
        // that.$refs.mqttws.disconnect()
        that.$router.push({
          path:'/toolCabinet/CCloseDoor',
          query:{
            boxId:that.boxId,
            type:'1',//1借用2归还3管理员入库（自定义）
          }
        })
      }else{
        clearTimeout(that.timeStatus2)
        // that.$refs.mqttws.disconnect()
        that.$message.error(res.meta.message)
        that.$router.push({
          path:'/toolCabinet/CBorrow',
        })
      }
    },
    //接收mqtt信息
    getMessage(data){
      var that = this;
      if(data){
        var str = data.substring(2,data.length-2);//截取字符串的第二到倒数第二的数据
        var str2 = data.substring(2,data.length);
        var num = checkData(str)
        var bbc = data.substr(data.length-2)
        // var id = str.substring(str.length-4,str.length)
        var type = str.substring(26,30)
        // if(lastTwo == 55 && num == bbc){
        if( type == 'd608'){
          var lastTwo = str.substring(str.length-2,str.length)
          if(num == bbc && lastTwo == '01'){
            topic = '/'+ config.clientPort +'/report/'+ config.serverPort +'/environment/protocol'
            that.$refs.mqttws.onConnect(topic)
          }else{
            var boxId = that.boxId
            // if(boxId <= 9){
            //   boxId = '0'+boxId
            // }
            var topic = '/'+ config.serverPort +'/down/'+ config.clientPort +'/control/protocol'
            var msg = 'a5551505160101010000000101d6080001'+boxId
            var num2 = checkData(msg)
            msg = msg+num2
            // console.log('topic',topic)
            // console.log('msg',msg)
            that.$refs.mqttws.send(topic,msg)
          }
        }else if( type == 'd707'){
          var lastTwo = str.substring(str.length-2,str.length)
          if(num == bbc && lastTwo == '01'){
            topic = '/'+ config.clientPort +'/report/'+ config.serverPort +'/environment/protocol'
            that.$refs.mqttws.onConnect(topic)
          }else{
            var boxId = that.boxId
            // if(boxId <= 9){
            //   boxId = '0'+boxId
            // }
            var topic = '/'+ config.serverPort +'/down/'+ config.clientPort +'/control/protocol'
            var msg = 'a5551505160101010000000101d7070001'+boxId
            var num2 = checkData(msg)
            msg = msg+num2
            // console.log('topic',topic)
            // console.log('msg',msg)
            that.$refs.mqttws.send(topic,msg)
          }
        }else if(type == 'df10'){
          var lastTwo = str.substring(36,38)
          if(lastTwo == '01'){
            //clearTimeout(that.timeStatus2)
            that.borrowReturn(str2)
          }else{
            var boxId = that.boxId
            // if(boxId <= 9){
            //   boxId = '0'+boxId
            // }
            var topic = '/'+ config.serverPort +'/down/'+ config.clientPort +'/control/protocol'
            var msg = 'a5551505160101010000000101d6080001'+boxId
            var num2 = checkData(msg)
            msg = msg+num2
            // console.log('topic',topic)
            // console.log('msg',msg)
            that.$refs.mqttws.send(topic,msg)
          }
          
        }else if(type == 'd708'){
          var lastTwo = str.substring(36,38)
          if(lastTwo == '01'){
            // that.borrowReturn(str2)
            //clearTimeout(that.timeStatus2)
            that.borrowReturn2(str2)
          }else{
            var boxId = that.boxId
            // if(boxId <= 9){
            //   boxId = '0'+boxId
            // }
            var topic = '/'+ config.serverPort +'/down/'+ config.clientPort +'/control/protocol'
            var msg = 'a5551505160101010000000101d7070001'+boxId
            var num2 = checkData(msg)
            msg = msg+num2
            // console.log('topic',topic)
            // console.log('msg',msg)
            that.$refs.mqttws.send(topic,msg)
          }
          
        }
      }
    },
  },
  watch :{
    "$store.state.wsMsg":function(newVal){
      this.getSkMsg(newVal)
    }
  },
}
</script>

<style lang="less">
.CInventory{
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  // background: url('../../../../../../static/images/bg.jpg') center no-repeat;
  // background-size: cover;
  .icon{
    width: 1.67rem;
    height: 1.67rem;
    margin: 0 auto;
    img{width: 100%;}
  }
  .name{
    font-size: 0.5rem;
    margin: 0.8rem 0 0.27rem;
    span{color:#fff;}
  }
  .currTime{
    position: absolute;
    right: 0.2rem;
    top: 0.2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CToolCabinet/page/CEmployee/CBorrow/CInventory.vue